/**
 * @memberof activerecord.errors
 */
class ActiveRecordError {
    constructor(props) {
        this.response = props.response;
        this.body = props.body;
    }
    /**
     * @type {number}
     */
    get status() {
        return this.response.status;
    }
}
export default ActiveRecordError;
